import {InputTextV2} from '@prtimes-basis/input';
import {FormField, useFormField} from '../../../form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function EmailCcField() {
  return (
    <FormField.Root name='billingInfo.emailCc'>
      <Body />

      <FormField.Error />

      <FormField.Description>
        請求書はメールにて送付しております。請求書送付先のメールアドレスをご入力ください
      </FormField.Description>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField({
    hasDescription: true,
  });

  return (
    <InputTextV2
      type='email'
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      {...fieldProps}
    />
  );
}
